import React from 'react';
import './ServicePage.css';

import { Heading, Service, PageTitle } from '../../../components';
import { services } from '../../../constants';

const ServicePage = () => {

    return (
        <>
            {/* Page Title */}
            <PageTitle title={'Oferta'} page={'Services'} subTitle={'Ogród w Imielnie to przestrzeń, w której historia spotyka się z naturą, a odpoczynek przeplata się z edukacją i kulturą. To wyjątkowe miejsce stworzone z pasją, pełne roślin, zieleni i inspiracji, otwarte dla gości, grup, szkół i wszystkich, którzy pragną spędzić czas w otoczeniu piękna. Zapraszamy do korzystania z naszej oferty — każdy znajdzie u nas coś dla siebie.'} />

            <section className='services'>

                {/* Section heading */}
                <Heading title={'Nasza oferta'} subTitle={'Co oferujemy'} />

                <div className='box-container'>

                    {/* Map over the services array to render each service */}
                    {services.map((service) => {
                        return (
                            <Service
                                id={service.id}
                                key={service.id}
                                image={service.image}
                                title={service.title}
                                content={service.content} 
                                service={service} 
                                icon={service.icon}
                            />
                        );
                    })}
                </div>

            </section>
        </>
    )
}

export default ServicePage;